import { useState } from 'react';
import { toast } from 'react-toastify';
import { createControlSocialActivity } from '../../../API/apiService';
import CustomFilterSelect from '../../../shared/customFilterSelect';
import { SOCIAL_CONTROL_LINES } from './catalogs';
import '../createSchool/style.scss';

const ACTIVITY_NAME_MAX_LENGTH = 255;

function getOptionName(options, optionId) {
  return (
    options.find(option => String(option?.id) === String(optionId))?.name || ''
  );
}

function CreateSocialControl({ setOpenModal, created }) {
  const [submitting, setSubmitting] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    line: ''
  });

  const selectedLineLabel = getOptionName(
    SOCIAL_CONTROL_LINES,
    formData.line
  );

  function handleNameChange(event) {
    setFormData(previous => ({
      ...previous,
      name: event.target.value
    }));
  }

  function selectLine(_selectName, id) {
    setFormData(previous => ({
      ...previous,
      line: id || ''
    }));
  }

  async function submitSocialControl() {
    const name = String(formData.name || '').trim();
    const line = String(formData.line || '').trim();
    const isAllowedLine = SOCIAL_CONTROL_LINES.some(
      option => option.id === line
    );

    if (!name) {
      toast('Por favor ingrese el nombre de la actividad', {
        type: 'warning'
      });
      return;
    }

    if (!isAllowedLine) {
      toast('Por favor seleccione la línea', {
        type: 'warning'
      });
      return;
    }

    try {
      setSubmitting(true);
      const response = await createControlSocialActivity({ name, line });

      if (response?.success) {
        setOpenModal(false);
        created(response.data || true);
      }
    } catch (error) {
      const errorCode = error?.response?.data?.message;
      const errorMessages = {
        ACTIVITY_NAME_INVALID: 'Ingrese un nombre de actividad válido',
        ACTIVITY_LINE_INVALID: 'Seleccione una línea válida',
        SOCIAL_CONTROL_ROLE_REQUIRED:
          'La sesión no corresponde a un Mediador Control Social',
        ACTIVITY_SAVE_FAILED: 'No fue posible guardar la actividad'
      };

      toast(
        errorMessages[errorCode] ||
          'Error creando la actividad de Control Social',
        { type: 'error' }
      );
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className='main-create-container'>
      <p className='title'>CREAR ACTIVIDAD</p>

      <section className='create-container'>
        <label className='label'>
          <input
            placeholder='Nombre de la actividad'
            type='text'
            name='name'
            className='input-form'
            maxLength={ACTIVITY_NAME_MAX_LENGTH}
            value={formData.name}
            onChange={handleNameChange}
          />
        </label>

        <CustomFilterSelect
          optionsList={SOCIAL_CONTROL_LINES}
          placeholder='Línea'
          addInfo={selectLine}
          valueEdit={selectedLineLabel}
        />

        <div className='buttons-container'>
          <button
            className='blue-site-button create'
            onClick={submitSocialControl}
            type='button'
            disabled={submitting}
          >
            {submitting ? 'CREANDO...' : 'CREAR'}
          </button>
          <button
            className='button-white-border-blue'
            onClick={() => setOpenModal(false)}
            type='button'
            disabled={submitting}
          >
            CANCELAR
          </button>
        </div>
      </section>
    </section>
  );
}

export default CreateSocialControl;
